import { useGetApiV1ExamLangsExamlangidItems } from '@/shared/api/generated';
import type { ExamItemLangGridItemViewModel } from '@/shared/api/generated/types/ExamItemLangGridItemViewModel';
import { unwrapPagedResponse } from '@/shared/utils/unwrapPagedResponse';

/**
 * Hook para listar questões de um idioma de prova.
 *
 * @param examLanguageId - ID do idioma da prova
 * @returns Lista de questões com estado de loading/error
 *
 * @example
 * ```tsx
 * const { questions, isLoading } = useExamQuestions(examLanguageId);
 * ```
 */
export function useExamQuestions(examLanguageId: number) {
  const query = useGetApiV1ExamLangsExamlangidItems(examLanguageId);

  return {
    questions: unwrapPagedResponse<ExamItemLangGridItemViewModel>(query.data),
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
